import React from "react";
import "./loader.css";
const Loader = () => {
  return (
    <>
   <div id="container">
  <div className="circle" />
  <div className="loader1" />
  <div className="loader2" />
  <div className="loader3" />
  <div className="loader4" />
</div>

    </>
  );
};

export default Loader;
